$(function () {
    'use strict';
    $("form.js-reports-add-selected-tab").on('submit', function() {
        var tab_group_name = $(this).data('tab-name');
        var $nav = $('nav.' + tab_group_name);
        if ($nav.length) {
            var $selected = $nav.find('li.is-selected');
            if ($selected.length) {
                $(this).find('input.js-selected-tab').val($selected.data('tab-name'));
            }
        }
    });

    // _report_form.html.erb 内のinputに対してEnterキーの無効化
    $('form.js-report-form-input-disabled-enter-key').on('keydown', function(event) {
        // input系の場合のみEnterキーの無効化、他のHTMLタグには効かないようにする
        if (event.key === 'Enter' && event.target.tagName.toLowerCase() === 'input') {
            event.preventDefault(); // Enterキーのデフォルト動作を無効化
        }
    });
});
